import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  getDisplayCurrencySymbol,
  getIndianNumberSystemEnabled,
  getIsCurrencySymbolAfterAmount,
  getReplaceCurrencySymbolForMatchedAndTooltips
} from 'redux/modules/appConfigs/selectors';
import { getPrecisionType, getUserCurrency } from 'redux/modules/user/selectors';
import { getFormatValueWithCurrency, Settings } from 'utils/currency';

import { useCurrency } from './useCurrency';

export const useFormatCurrency = (
  amount: number | string,
  currencyCode?: string,
  settings: Settings = {
    noCommas: false,
    noRounding: false,
    isCheckIndian: false,
    noSymbol: false,
    ignorePrecision: false,
    placement: undefined,
    fractionDigits: '',
    hideCurrencySymbol: false,
    ignoreFlexibleDisplayFormat: false,
    alwaysFlexibleDisplayFormat: false,
    noZeroSign: false,
    isPositiveSign: false,
    useFlexibleFromMillion: false
  }
) => {
  const { t } = useTranslation();

  const displayCurrencySymbol = useSelector(getDisplayCurrencySymbol);
  const currencySymbolAfterAmount = useSelector(getIsCurrencySymbolAfterAmount);
  const indianNumberSystemEnabled = useSelector(getIndianNumberSystemEnabled);
  const replaceCurrencySymbolForMatchedAndTooltips = useSelector(getReplaceCurrencySymbolForMatchedAndTooltips);
  const userCurrency = useSelector(getUserCurrency);
  const precisionType = useSelector(getPrecisionType);

  const currency = useCurrency(currencyCode || userCurrency);

  return getFormatValueWithCurrency({
    amount,
    settings,
    t,
    displayCurrencySymbol,
    currency,
    currencySymbolAfterAmount,
    indianNumberSystemEnabled,
    replaceCurrencySymbolForMatchedAndTooltips,
    precisionType
  });
};
